import { G_runningElements } from "../../utils/globals/running";
import WINDOW from "../../utils/window";
import startRaf from "./start-raf";

/**
 * Run event
 * @param {CustomEventProps} event
 * @param {"enter" | "leave"} mode
 * @param {Boolean} [isActive]
 * @param {TriggerProps | null} [TRIGGER] Global trigger (scroll)
 * @param {MainClassProps | null} [MAIN] Global main class (scroll)
 */
const run = (event, mode, isActive = false, TRIGGER = null, MAIN = null) => {
  /** Get the trigger from the event */
  const trigger =
    TRIGGER || /** @type {TriggerMapProps} */ (event?.details?.get("trigger"));

  /** Return, if trigger is not in resolution */
  if (!trigger.get("is-in-resolution")) {
    return;
  }

  /** If trigger is in "leave" mode, for example, it cannot be triggered to play a "leave" mode again */
  if (
    mode === trigger.get("mode") &&
    trigger.get("original-name") === "select"
  ) {
    return;
  }

  const now = /** @type {Number} */ (WINDOW.get("time"));

  /**
   * In case extreme fast mode change (fast hover in/out), modes are changing in the same animation frame.
   * So when animation is reverting back in "leave" mode, it changes fast from "enter" to "leave",
   * but only the "leave" mode is used in the next animation frame. But the "start-time" changes also,
   * so even, if the mode is still "leave", the "start-time" forces the animation to recalculate the percentage.
   *
   * This prevents from setting the start-time and keep the mode in "leave" state
   */
  if (
    trigger.get("last-now") === now &&
    !trigger.get("animate") &&
    mode !== trigger.get("last-mode")
  ) {
    trigger.set("enter", false);
    trigger.set("leave", true);
    trigger.set("mode", "leave");
    trigger.set("start-time", trigger.get("last-leave-start-time"));

    return;
  }

  /** Get the `main` from the event */
  const main = MAIN || /** @type {MainClassProps} */ (event?.details?.get("main"));

  /** Trigger name */
  const name = /** @type {String} */ (trigger.get("name"));

  /** Timeline associated with a trigger */
  const timeline = /** @type {TimelineMapProps} */ (trigger.get("timeline"));

  /** Mode type opposite */
  const type = mode === "enter" ? "leave" : "enter";

  trigger.set("start-time", null);
  trigger.set("mode-switch", true);
  trigger.set("enter", mode === "enter");
  trigger.set("leave", mode === "leave");
  trigger.set("mode", mode);
  trigger.set("last-mode", mode);
  trigger.set("last-now", now);
  trigger.set("is-active", isActive);

  timeline.set(`${type}-time`, null);
  timeline.set("paused", false);
  timeline.set("pause-enter-time", null);
  timeline.set("finished", false);
  timeline.set("started", false);

  /** Add a `main` class to the currently running elements map */
  G_runningElements.set(main.element, main);

  /** Add the trigger name into local `activeTriggers` */
  main.activeTriggers.add(name);

  /** Start RAF if not running */
  startRaf();
};


export default run;
